import MobileSearch from '../components/search/MobileSearch';
import Scroll from '../helpers/scroll';
import Search from '../components/search/Search';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../helpers';
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const selectors = {
  headerNavigation: '[data-header-navigation]',
  navHamburger: '[data-nav-hamburger]',
  megaDetails: '[data-mega-details]',
  navClose: '[data-nav-close]',
  announcementBar: '[data-announcement-bar]',
  megaBackButton: '[data-submenu-back]',
  megamenuCarousel: '[data-megamenu-carousel]',
  mobileLinkLevel2: '[data-mobile-link-level-2]',
  mobileListLevel2: '[data-mobile-list-level-2]',
  mobileSubmenuBack: '[data-mobile-submenu-back]',
};

export default class MainHeader {
  constructor(section) {
    this.section = section;

    const { settings } = section.data;

    if (settings.enable_fixed_header) {
      this.listener = new Scroll(this.onScroll, this.section.el);
      this.section.el.className +=
        ' sticky top-0 z-50 bg-white transition-transform';
    }

    const megaDetails = this.section.el.querySelectorAll(selectors.megaDetails);
    megaDetails.forEach(detail => {
      detail.addEventListener('toggle', ({ newState }) => {
        if (window.innerWidth >= unitlessBreakpoints.lg) {
          if (newState === 'open') {
            disablePageScroll();
          } else {
            enablePageScroll();
          }
        }
      });
    });

    new Search(section);
    new MobileSearch(section);

    this.initMobileNavigation();
    this.initMegamenuCarousel();
  }

  onScroll = direction => {
    if (direction === 'up') {
      this.showMenu();
    } else if (direction === 'down') {
      this.hideMenu();
    }
  };

  showMenu = () => {
    this.section.el.classList.remove('-translate-y-full');
  };

  hideMenu = () => {
    this.section.el.classList.add('-translate-y-full');
  };

  initMobileNavigation = () => {
    const megaBackButtons = this.section.el.querySelectorAll(
      selectors.megaBackButton,
    );

    this.openMobileNav();
    this.closeMobileNav();
    this.initMobileLevel2Click();

    // Set subnav heights
    megaBackButtons.forEach(button => {
      button.addEventListener('click', () => {
        const parentDetail = button.closest('details');
        parentDetail.removeAttribute('open');
      });
    });
  };

  openMobileNav = () => {
    const headerNavigation = this.section.el.querySelector(
      selectors.headerNavigation,
    );
    const navHamburger = this.section.el.querySelector(selectors.navHamburger);
    const navClose = this.section.el.querySelector(selectors.navClose);
    navHamburger.addEventListener('click', () => {
      const totalHeaderHeight = this.getHeaderHeight();
      headerNavigation.style.top = `${totalHeaderHeight - 1}px`;
      navHamburger.classList.add('hidden');
      navClose.classList.remove('hidden');
      headerNavigation.classList.remove('hidden');
      headerNavigation.classList.add('flex');
      disablePageScroll();
    });
  };

  closeMobileNav = () => {
    const headerNavigation = this.section.el.querySelector(
      selectors.headerNavigation,
    );
    const navHamburger = this.section.el.querySelector(selectors.navHamburger);
    const navClose = this.section.el.querySelector(selectors.navClose);
    navClose.addEventListener('click', () => {
      navHamburger.classList.remove('hidden');
      navClose.classList.add('hidden');
      headerNavigation.classList.add('hidden');
      headerNavigation.classList.remove('flex');
      enablePageScroll();
    });
  };

  getHeaderHeight = () => {
    const announcementBar = document.querySelector(selectors.announcementBar);
    const headerHeight = this.section.el.offsetHeight;
    let announcementBarHeight = 0;
    if (announcementBar) {
      const announcementElementHeight = announcementBar.offsetHeight;
      if (document.documentElement.scrollTop < announcementElementHeight) {
        announcementBarHeight =
          announcementBar.offsetHeight - document.documentElement.scrollTop;
      }
    }
    return headerHeight + announcementBarHeight;
  };

  initMegamenuCarousel = () => {
    const megamenuCarouselList = this.section.el.querySelectorAll(
      selectors.megamenuCarousel,
    );

    megamenuCarouselList.forEach(carousel => {
      const megamenuCarousel = new Splide(carousel, {
        perPage: 1,
        pagination: false,
        arrows: false,
        gap: '1rem',
        mediaQuery: 'min',
        padding: {
          right: '10%',
        },
        breakpoints: {
          420: {
            perPage: 1,
            padding: {
              right: '30%',
            },
          },
          [unitlessBreakpoints.sm]: {
            perPage: 2,
            padding: {
              right: '15%',
            },
          },
          [unitlessBreakpoints.md]: {
            perPage: 3,
            padding: {
              right: '10%',
            },
          },
          [unitlessBreakpoints.lg]: {
            destroy: true,
          },
        },
      });

      megamenuCarousel.mount();
    });
  };

  initMobileLevel2Click = () => {
    const mobileLinkLevel2Elements = this.section.el.querySelectorAll(
      selectors.mobileLinkLevel2,
    );
    const mobileSubmenuBackElements = this.section.el.querySelectorAll(
      selectors.mobileSubmenuBack,
    );

    mobileLinkLevel2Elements.forEach(element => {
      element.addEventListener('click', event => {
        // Only fire on mobile sizes (under lg breakpoint)
        if (window.innerWidth < unitlessBreakpoints.lg) {
          console.log('Mobile level 2 clicked', event.target);
          const mobileListLevel2 = event.target.nextElementSibling;
          mobileListLevel2.classList.toggle('hidden');
        }
      });
    });

    mobileSubmenuBackElements.forEach(backButton => {
      backButton.addEventListener('click', event => {
        // Only fire on mobile sizes (under lg breakpoint)
        if (window.innerWidth < unitlessBreakpoints.lg) {
          const mobileListLevel2 = backButton.closest(
            selectors.mobileListLevel2,
          );
          if (mobileListLevel2) {
            mobileListLevel2.classList.add('hidden');
          }
        }
      });
    });
  };
}
